import React from 'react';
import GenericPullConfigListing from '../GenericPullConfigListing';
import GithubSecretScanMappingForm from './GithubSecretScanMappingForm';
import GithubSecretScanCredentialsForm from './GithubSecretScanCredentialsForm';
import { columnRenderArrayData } from 'utils/tableUtils';

const GithubSecretScanConfigListing = (props) => {
    const columns = [{
        title: "Repository",
        dataIndex: "repositoryName",
        render: columnRenderArrayData,
        width: 200
    }]
    
    return (
    <GenericPullConfigListing
        {...props}
        toolName={props.name}
        MappingForm={GithubSecretScanMappingForm}
        CredentialsForm={GithubSecretScanCredentialsForm}
        extraColumns={columns}
    />)
}

export default GithubSecretScanConfigListing;
